import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['card', 'button', 'saveForm', 'resetForm', 'done', 'instruction' ]

  initialize() {
    this.ask()
  }

  select(event) {
    const button = event.currentTarget
    const question = this.questionCard
    
    if (question && question.dataset.cms === button.dataset.cms) {
      // Correct match
      question.classList.remove('match-word-asked')
      question.classList.add('match-word-muted')
      question.classList.add('match-word-done')
      button.disabled = true
      button.classList.add('btn-outline-success')
      button.classList.remove('btn-outline-dark')
      console.log('✓ Correct match:', button.textContent)
      this.ask()
    } else {
      // Wrong match - show feedback
      button.classList.add('btn-outline-danger')
      button.classList.remove('btn-outline-dark')
      setTimeout(() => {
        button.classList.remove('btn-outline-danger')
        button.classList.add('btn-outline-dark')
      }, 500)
      console.log('✗ Wrong match - try again')
    }
  }

  get questionCard() {
    return this.cardTargets.find((card) => { 
      return card.classList.contains('match-word-asked') 
    })
  }

  ask() {
    const unasked = this.cardTargets.find((card) => { 
      return card.classList.contains('match-word-unasked') 
    })

    if (unasked) {
      unasked.classList.remove('match-word-unasked')
      unasked.classList.add('match-word-asked')
      console.log('Next question:', unasked.querySelector('.match-word-keyword')?.textContent)
    } else {
      this.finish()
    }
  }

  finish() {
    this.saveFormTarget.requestSubmit()
    this.element.dispatchEvent(new CustomEvent('exercisedone', { bubbles: true }))
    this.doneTarget.classList.remove('d-none')
    this.resetFormTarget.classList.remove('d-none')
    this.instructionTarget.classList.add('d-none')
    this.buttonTargets.forEach(b => { b.classList.add('d-none') })
    this.cardTargets.forEach(c => { c.classList.remove('match-word-muted') })
    console.log('✓ Word match completed!')
  }

  async reset(event) {
    // Prevent Turbo from handling the response (we're doing it manually)
    event.preventDefault()

    // Fire custom event before reset
    this.element.dispatchEvent(new CustomEvent('exercisereset', { bubbles: true }))
    
    let response
    
    // Turbo format: event.detail.fetchResponse.responseText is a Promise
    if (event.detail?.fetchResponse) {
      try {
        response = await event.detail.fetchResponse.responseText
      } catch (e) {
        console.error('Error extracting Turbo response:', e)
      }
    }
    
    if (response && typeof response === 'string' && response.trim().length > 0) {
      this.element.parentNode.innerHTML = response
      console.log('✓ Activity reset successful')
    } else {
      console.error('⚠️ Reset failed: No valid response', { detail: event.detail })
      alert('Failed to reset activity. Please refresh the page and try again.')
    }
  }
}
